import { first } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { TokenService } from 'src/app/services/common/token.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { Location } from '@angular/common'


@Component({
  selector: 'app-vendor-mi-estimation-consent-form',
  templateUrl: './vendor-mi-estimation-consent-form.component.html',
  styleUrls: ['./vendor-mi-estimation-consent-form.component.scss']
})
export class VendorMiEstimationConsentFormComponent implements OnInit {

  items: any[];
  selectedStatus: any;
  remarks: String;
  appId: String;
  vendorId: String;
  programId: String;
  applicationDetails: any;
  applicationDetailsForViewOnly: any;
  isActionSectionEnabled: boolean;

  public isProDataCalculated: boolean = false;
  public proCalculatedData: any;
  public statusCode: any;
  public userID: any;
  public preEstimateDetails: any;
  public showMap: any;
  public options: any;
  public overlays: any[];

  public cropType: any;
  public selectedCropType: any;
  public selectedCrop: any;
  public currentDateTime: any;

  public preEstimationDataArray: any = [];

  optionsPreEstimate: any;
  overlaysPreEstimate: any[];
  showMapPreEstimate: any;
  viewWorkFlowAllStatus: boolean = false;

  activeIndex: any;
  displayCustom: any;
  imgVal: any;

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];

  public existingMIDetails: any = [];
  public dimicadaLogin: boolean = false;
  public ddAssociateLogin: boolean = false;

  public selLandForOwnerdetails: any = {};
  public kewatNo: any = null;

  public displayLandOwnerDialog: boolean = false;
  public landOwnerDetails : any = [];
  public showLandOwnerDetails: boolean = false;

  public isLandOwnerDetFetching: boolean = false;
  loadingText: string = 'Fetching Owner Details from Land Revenue Department';
  private dotCount: number = 0;
  private maxDots: number = 3;
  private interval: any;

  public landOwnerDetailsErrorMsg: any = null;
  public showHiddenButton: boolean = false;
  public request1complete: boolean = false;
  public request2complete: boolean = false;
  public landDetailedInfo: any = [];
  public userRole: any = null;

  constructor(
    private deptDashBoardService: DepartmentDashboardService, 
    private messageService: MessageService, 
    private vendorService: VendorDashboardService, 
    private router: Router, 
    private route: ActivatedRoute, 
    private tokenService: TokenService, 
    private cryptoJsService: CryptoJsService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private _dashboardService: DashboardService,
    private location: Location,
    ) { }

  ngOnInit(): void {
    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);
    const tokenInfo = loginDetails.get('tokenInfo') ? loginDetails.get('tokenInfo') : null;
    this.userRole = tokenInfo['role'] ? tokenInfo['role'] : null;

    const tokenData = sessionStorage.getItem('token')
    ? JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')))
    : {};
    
    if (tokenData && tokenData.role == 'DMICADA') {
      this.dimicadaLogin = true
    }
    if (tokenData && tokenData.role == 'DD Associate') {
      this.ddAssociateLogin = true
    }

    
    this.route.queryParams.subscribe(params => {
      const encryptedAppId = params['appId'];
      const encryptedVendorId = params['vendorId'];
      const encryptedProgId = params['programId'];
      if (encryptedAppId) {
        this.appId = this.cryptoJsService.DecryptData(encryptedAppId);
        this.vendorId = this.cryptoJsService.DecryptData(params['vendorId']);
        this.programId = this.cryptoJsService.DecryptData(params['programId']);
        
      }else{
        setTimeout(()=> this.onClickBack(), 1300);
      }
    });

    // this.appId = this.cryptoJsService.DecryptData(this.route.snapshot.paramMap.get('appId'));
    // this.vendorId = this.route.snapshot.paramMap.get('vendorId');
    // this.programId = this.route.snapshot.paramMap.get('programId');

    this.currentDateTime = new Date();

    this.getCropMaster();
    this.getApplicationDetails(this.appId);
    this.getExistingMIDetails(this.appId);


    this.route.queryParams
      .subscribe(params => {
        this.statusCode = this.cryptoJsService.DecryptData(params.statusCode);
        if (params.statusCode == this.cryptoJsService.Encrypt('C') || params.statusCode == this.cryptoJsService.Encrypt('P')) {
          this.isActionSectionEnabled = true;
        } else {
          this.isActionSectionEnabled = false;
        }
      }
      );


    // if (this.appId && this.programId) {
    //   this.deptDashBoardService.getApplicationDataOfPreEstimation(this.appId, this.programId)
    //     .pipe(first())
    //     .subscribe({
    //       next: (data) => {
    //         this.preEstimateDetails = data;

    //         if(this.preEstimateDetails.CropTypeID && this.preEstimateDetails.CropId){
    //           this.cropType.forEach((res) => {
    //             if (res.data === data.CropTypeID) {
    //               this.selectedCropType = res.label;
    //               let crop = res.children;
    //               crop.forEach((res2) => {
    //                 if(res2.data === data.CropId){
    //                   this.selectedCrop = res2.label;
    //                 }
    //               })
    //               return;
    //             }
    //           });
    //         }


    //         if( this.preEstimateDetails.listGPSCoordinates.length>0){
    //           this.showMap=true;
    //           let locationArray = []
    //         this.preEstimateDetails.listGPSCoordinates.forEach(e => {
    //           locationArray.push({ lat: e.Latitude, lng: e.Longitude })
    //         })
    //         this.options = {
    //           center: { lat: locationArray[0].lat, lng: locationArray[0].lng },
    //           zoom: 12,
    //           mapTypeId: google.maps.MapTypeId.SATELLITE
    //         };
    //         let pointLocations = [];
    //         locationArray.forEach(e => { pointLocations.push(new google.maps.Marker({ position: { lat: e.lat, lng: e.lng } })) });
    //         this.overlays = [
    //           ...pointLocations,
    //           new google.maps.Polygon({
    //             paths: [...locationArray], strokeOpacity: 0.5, strokeWeight: 1, fillColor: '#1976D2', fillOpacity: 0.35
    //           }),


    //         ];
    //         }
    //         else{
    //           this.showMap=false;
    //         }
            
    //       },
    //       error: () => {
    //         // this.loader.close();
    //         // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Vendor Consent Form Not Loaded' });
    //       }
    //     });
    // }

    if (!this.appId && !this.vendorId && !this.programId) {
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Cannot Load Form Due to Missing Parameters' });
    }
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    this.activityRecordService.activityRecord(this.userID, 'View Vendor MI Estimation For Approval', this.appId, new Date(), 'Success');

    let actionId = 14; // Do not Change, it is fixed for Farmer Application Verifications
    this.loader.start();
    this.deptDashBoardService.GetStatusMaster(JSON.parse(payload)?.sub, actionId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.items = data.$values;
          this.selectedStatus = this.items[0];
          this.onSelectStatus();
          this.loader.close();
        },
        error: () => {
          this.loader.close();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Status Master cant be Loaded' });
        }
      });

    this.loader.start();
    this.deptDashBoardService.getVendorMIEstimation(this.appId, this.vendorId, this.programId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.applicationDetails = data;          
          this.loader.close();
        },
        error: () => {
          this.loader.close();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Vendor Consent Form Not Loaded' });
        }
      });

  }

  onClickBack(){
    this.location.back();
  }

  handleClick() {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);

    let reqBody = {
      AppId: this.appId,
      Userid: JSON.parse(payload)?.sub,
      Remarks: this.remarks,
      Status: this.selectedStatus.flag,
      ProgId: this.programId
    }

    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.deptDashBoardService.insertVendorMIEstimateForApproval(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.activityRecordService.activityRecord(this.userID, 'Submit Approval', this.appId, new Date(), this.selectedStatus.status);
          let resp = JSON.stringify(data);
          if (resp.startsWith('"S')) {
            this.messageService.add({
              severity: 'success',
              summary: 'Status',
              detail: resp,
            });
          }
          else {
            this.messageService.add({
              severity: 'error',
              summary: 'Status',
              detail: resp,
            });
          }

          if (data == 'S:Successfully Submitted' || data =='S:Successfully Updated' || resp.startsWith('"S')) {

            let componentName = window.sessionStorage.getItem('currentComponentName');

            if (this.userRole == 'DDMI' || this.userRole == 'DDTank') {

              // let applications = JSON.parse(window.sessionStorage.getItem("miVendorApplicationForApproval"));
              let applications = JSON.parse(window.sessionStorage.getItem(componentName));
              if(applications!=null){

                applications.filter(application => {
                  return application.AppID === this.appId
                }).forEach(element => {
                  // element.Status_Ar = this.selectedStatus.flag == 'A' ? 'A' : 'C',
                    element.Status_Ar = 'C',
                    element.Status = this.selectedStatus.flag == 'A' ? 'Approved' : (this.selectedStatus.flag == 'RP') ? 'Return Process' : (this.selectedStatus.flag == 'R') ? 'Rejected' : 'Marked Return',
                    element.NextLevelID = 'DDMICADA',
                    element.Remarks = this.remarks
  
                });
              }
              // sessionStorage.setItem('miVendorApplicationForApproval', JSON.stringify(applications));
              sessionStorage.setItem(componentName, JSON.stringify(applications));

            }else if (this.userRole == 'DD Associate') {

              // let applications = JSON.parse(window.sessionStorage.getItem("miVendorApplicationForApproval"));
              let applications = JSON.parse(window.sessionStorage.getItem(componentName));
              if(applications!=null){

                applications.filter(application => {
                  return application.AppID === this.appId
                }).forEach(element => {
                  // element.Status_Ar = this.selectedStatus.flag == 'A' ? 'A' : 'C',
                    element.Status_Ar = 'C',
                    element.Status = this.selectedStatus.flag == 'A' ? 'Approved' : (this.selectedStatus.flag == 'RP') ? 'Return Process' : (this.selectedStatus.flag == 'R') ? 'Rejected' : 'Marked Return',
                    element.NextLevelID = 'DDMI',
                    element.Remarks = this.remarks
  
                });
              }
              // sessionStorage.setItem('miVendorApplicationForApproval', JSON.stringify(applications));
              sessionStorage.setItem(componentName, JSON.stringify(applications));

            } else if (this.userRole == 'DDMICADA') {

              // let applications = JSON.parse(window.sessionStorage.getItem("miVendorApplicationForApproval"));
              let applications = JSON.parse(window.sessionStorage.getItem(componentName));
              if(applications!=null){

                applications.filter(application => {
                  return application.AppID === this.appId
                }).forEach(element => {
  
                  let nextLevelId;
                  if (this.selectedStatus.flag == 'A') {
                    nextLevelId = 'DMICADA';
                  } else if (this.selectedStatus.flag == 'RP') {
                    nextLevelId = 'Vendor'
                  } else if (this.selectedStatus.flag == 'R') {
                    nextLevelId = 'N/A'
                  }
  
                  element.Status_Ar = this.selectedStatus.flag == 'A' ? 'A' : 'C',
                  element.Status_Ar = 'C',
                    element.Status = this.selectedStatus.flag == 'A' ? 'Approved' : (this.selectedStatus.flag == 'RP') ? 'Return Process' : (this.selectedStatus.flag == 'R') ? 'Rejected' : 'Marked Return',
                    element.NextLevelID = nextLevelId,
                    element.Remarks = this.remarks
  
                });
              }
              // sessionStorage.setItem('miVendorApplicationForApproval', JSON.stringify(applications));
              sessionStorage.setItem(componentName, JSON.stringify(applications));
            }
            else if (this.userRole == 'DMICADA') {

              // let applications = JSON.parse(window.sessionStorage.getItem("miVendorApplicationForApproval"));
              let applications = JSON.parse(window.sessionStorage.getItem(componentName));
              if(applications!=null){

                applications.filter(application => {
                  return application.AppID === this.appId
                }).forEach(element => {
                  let nextLevelId;
                  if (this.selectedStatus.flag == 'A') {
                    nextLevelId = 'Farmer';
                  } else if (this.selectedStatus.flag == 'RP') {
                    nextLevelId = 'Vendor'
                  } else if (this.selectedStatus.flag == 'R') {
                    nextLevelId = 'N/A'
                  }
  
                    // element.Status_Ar = this.selectedStatus.flag == 'A' ? 'A' : 'C',
                    element.Status_Ar = 'C',
                    element.Status = this.selectedStatus.flag == 'A' ? 'Approved' : (this.selectedStatus.flag == 'RP') ? 'Return Process' : (this.selectedStatus.flag == 'R') ? 'Rejected' : 'Marked Return',
                    element.NextLevelID = nextLevelId,
                    element.Remarks = this.remarks
    
                });
              }
              // sessionStorage.setItem('miVendorApplicationForApproval', JSON.stringify(applications));
              sessionStorage.setItem(componentName, JSON.stringify(applications));
            }

            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Vendor Application Processed Successfully.' });
            
            setTimeout(()=> {
              if(componentName == 'miVendorApplicationForApprovalPending'){
                this.router.navigate(['department', 'vendor-mi-applications', 'pending']);
                // window.close();
              }
              else if(componentName == 'miVendorApplicationForApprovalCurrent'){
                this.router.navigate(['department', 'vendor-mi-applications', 'current']);
                // window.close();
              }
            },1000)
          }
        },
        error: (err) => {
          this.loader.close();
          this.activityRecordService.activityRecord(this.userID, 'Submit Approval', this.appId, new Date(), err);
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Cannot Process the MI Estimation Application' });
        }
      });
  }


  proDataCalculation() {
    const tableDataToPush: any = [];
    this.applicationDetails?.EstimationComponentDetail.forEach((row) => {
      tableDataToPush.push({
        cat: JSON.stringify(row.CatID),
        component: row.ComponentName,
        size: row.Size,
        quantity: row.Quantity,
        price: JSON.stringify(row.Price)
      });
    });

    // if (!(this.finalEstimationControls?.rowSpacing?.errors?.required || this.finalEstimationControls?.plantSpacing?.errors?.required || this.finalEstimationControls?.MIArea?.errors?.required)) {
    // this.showProDataCalError = false;
    let finalDataToPost = {
      estimationComponentDetail: tableDataToPush,
      programId: this.applicationDetails?.ProgID,
      applicationId: this.applicationDetails?.AppID,
      vendorId: JSON.stringify(this.applicationDetails?.vendorRegId),
      rowSpacing: this.applicationDetails?.RowSpacing,
      plantSpacing: this.applicationDetails?.PlantSpacing,
      area: this.applicationDetails?.MIArea,
    }
    let reqBody = finalDataToPost;

    this.getMaxSubsidy(reqBody);
    // }

    // else {
    //   this.showProDataCalError = true;
    // }

  }

  getMaxSubsidy(reqBody) {
    this.loader.start();
    this.vendorService
      .getMaxSubsidyEstimate(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.proCalculatedData = data;
          this.loader.close();
          this.isProDataCalculated = true;
          // this.messageService.add({
          //   severity: 'info',
          //   summary: 'Status',
          //   detail: data,
          // });
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
        // complete: () => {
        //   this.messageService.add({
        //     severity: 'success',
        //     summary: 'Success',
        //     detail: 'Estimation Updated Successfully',
        //   });
        // },
      });
  }

  onClickApp() {
    let statusCodeEncrypted = this.cryptoJsService.Encrypt(this.statusCode);
    const link = this.router.serializeUrl(
      this.router.createUrlTree([
        this.router.url.split('/')[1],
        'print',
      ],  { queryParams: { appId:this.cryptoJsService.Encrypt(this.appId.toString()) } }));
    // const link = this.router.serializeUrl(this.router.createUrlTree(['department', 'print', this.cryptoJsService.Encrypt(this.appId as string)]));
    window.open(link, '_blank');
  }

  // onPrint(divName) {
  //   var printContents = document.getElementById(divName).innerHTML;
  //   var originalContents = document.body.innerHTML;
  //   document.body.innerHTML = printContents;
  //   window.print();
  //   document.body.innerHTML = originalContents;
  // }

  getPreEstimationData(appId, programId) {
    if (appId && programId) {
      this.deptDashBoardService
        .getApplicationDataOfPreEstimation(appId, programId)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.preEstimateDetails = data;

            if (
              this.preEstimateDetails.CropTypeID &&
              this.preEstimateDetails.CropId
            ) {
              this.cropType.forEach((res) => {
                if (res.data === data.CropTypeID) {
                  // this.selectedCropType = res.label;
                  let crop = res.children;
                  crop.forEach((res2) => {
                    if (res2.data === data.CropId) {
                      this.preEstimateDetails = {
                        ...data,
                        selectedCropType: res?.label,
                        selectedCrop: res2.label,
                      };
                      // this.selectedCrop = res2.label;
                    }
                  });
                  return;
                }
              });
            }

            if (this.preEstimateDetails.listGPSCoordinates.length > 0) {
              this.showMapPreEstimate = true;

              let preEstimateOption = {
                center: { lat: 29.0588, lng: 76.0856 },
                zoom: 17,
                mapTypeId: google.maps.MapTypeId.SATELLITE,
                draggable: true,
              };

              if(this.preEstimateDetails?.listGPSCoordinates){
                preEstimateOption.center = {
                  "lat": this.preEstimateDetails?.listGPSCoordinates[0][0]?.Latitude,
                  "lng": this.preEstimateDetails?.listGPSCoordinates[0][0]?.Longitude
                };
              }
              let preEatimateOverlays = [];

              // add marker
              this.preEstimateDetails?.listGPSCoordinates.forEach((arr, tableIndex) => {
                arr.forEach((row, index) => {
                  preEatimateOverlays.push(
                    new google.maps.Marker({
                      position: { lat: row?.Latitude, lng: row?.Longitude },
                      title: `${row?.CornerID}`,
                      draggable: false,
                      crossOnDrag: false
                    })
                  );
                });
              })

              // add overlay

              // preEatimateOverlays.forEach((val, index) => {
              //   if(val?.fillColor){
              //     preEatimateOverlays.splice(index, 1);
              //   }
              // })
          
              this.preEstimateDetails.listGPSCoordinates.forEach(arr => {
                let arr1 = arr.map(val => ({
                  lat: val?.Latitude,
                  lng: val?.Longitude
                }))
                preEatimateOverlays.push(
                  new google.maps.Polygon({
                    paths: arr1,
                    strokeOpacity: 0.5,
                    strokeWeight: 1,
                    fillColor: '#1976D2',
                    fillOpacity: 0.35,
                  })
                );
              })

              this.preEstimateDetails = {
                ...this.preEstimateDetails,
                newGPSArray: {
                  gpsArray : this.preEstimateDetails.listGPSCoordinates,
                  preEatimateOverlays : preEatimateOverlays,
                  preEstimateOption: preEstimateOption
                } 
              }              
            } else {
              this.showMapPreEstimate = false;
            }

            this.preEstimationDataArray.push(this.preEstimateDetails);
          },
          error: () => {},
        });
    }
  }


  getApplicationDetails(appId) {
    this.loader.start();
    this._dashboardService.getApplicationByAppId(appId).subscribe((res) => {
      this.loader.close();
      if (res) {
        this.applicationDetailsForViewOnly = res;
        // this.applicationDetails = res;

        // res.ListViewFormData = [
        //   {
        //     "AutoId": 372819,
        //     "ProgId": 2,
        //     "VendorId": "302",
        //     "User_ID": "farmer"
        //   },
        //   {
        //     "AutoId": 372819,
        //     "ProgId": 2,
        //     "VendorId": "302",
        //     "User_ID": "farmer"
        //   }
        // ]

        if (this.applicationDetailsForViewOnly?.New_MI_Datas && this.applicationDetailsForViewOnly?.New_MI_Datas.length > 0) {
          this.applicationDetailsForViewOnly.New_MI_Datas = this.applicationDetailsForViewOnly.New_MI_Datas.filter((val) => {
            return (!(val?.miVendorName == null || val?.miVendorName == '') && !(val?.VendorCode == null && val?.VendorCode == 0))
          });
        }

        if (res.ListViewFormData && res.ListViewFormData.length > 0) {
          res.ListViewFormData.forEach((val) => {
            let autoId = val?.AutoId;
            let progId = val?.ProgId;
            // let userId = val?.User_ID;
            // let vendorId = val?.VendorId;

            // if (autoId && userId) {
            //   this.getCalculatedSubsidyDataForMIPhys(autoId, userId);
            // }

            if (autoId && progId) {
              this.getPreEstimationData(this.appId, progId);
            }

            // if (this.appId && progId) {
            //   this.getSanctionLetterData(this.appId, progId);
            // }

            // if (vendorId && progId) {
            //   this.getMIEstimationData(this.appId, vendorId, progId);
            //   this.getMIBOQData(this.appId, vendorId, progId);
            // }

            // if (autoId && userId) {
            //   this.getPhysicalSurveyData(autoId, userId);
            // }
          });
        }

        // if (
        //   this.applicationDetails.FarmerLand &&
        //   this.applicationDetails.FarmerLand.length > 0
        // ) {
        //   this.applicationDetails.FarmerLand.forEach(
        //     (val) => (this.totalLandArea += parseFloat(val.totalArea))
        //   );
        // }

        // this.totalArea = 0;
        // if (this.applicationDetails?.New_MI_Datas.length > 0) {
        //   this.applicationDetails.New_MI_Datas.forEach(
        //     (val) => (this.totalArea += parseFloat(val.totalArea))
        //   );
        // }
        // let farmerId = res.Farmer_ID;
        // if (res?.GroupTableData) {
        //   this.getPastSubsidiesByMultipleFarmerIds(res?.GroupTableData);
        // } else {
        //   this.getPastSubsidiesByFarmerId(farmerId);
        // }
      }
    });
  }

  getCropMaster() {
    // this.loader.start();
    this.vendorService
      .getCropMaster()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.cropType = res;
          // this.loader.close();
        },
        error: () => {
          // this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Crop Master not loaded.',
          });
        },
      });
  }

  workFlowAllStatus(){
    this.viewWorkFlowAllStatus = true;
  }

  imageClick(index: number, val) {
    this.activeIndex = index;
    this.displayCustom = true;
    this.imgVal = val;
  }

  getExistingMIDetails(appId){
    this._dashboardService.getExistingMIDetails(appId).subscribe((res) =>{
      this.existingMIDetails = res;
    })
  }

  beforeCheckingLandStatus(val){
    this.selLandForOwnerdetails = val;
    this.displayLandOwnerDialog = true;
  }

  startLoadingAnimation(): void {
    this.interval = setInterval(() => {
      this.dotCount = (this.dotCount + 1) % (this.maxDots + 1);
      this.loadingText = `Fetching Owner Details from Land Revenue Department${'.'.repeat(this.dotCount)}`;
    }, 500); // Adjust the interval (in ms) to control the speed of the animation
  }

  stopLoadingAnimation(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  onCloseLandOwnerDialog(){
    this.displayLandOwnerDialog = false;
    this.stopLoadingAnimation();
    this.selLandForOwnerdetails = null;
    this.kewatNo = null;
  
    this.landOwnerDetails = [];
    this.landOwnerDetailsErrorMsg = null;
  }

  submitKewatNo(){
    this.landOwnerDetails = [];
    this.landOwnerDetailsErrorMsg = null;
    if(this.kewatNo){
      this.checkLandStatus(this.selLandForOwnerdetails);
    }
  }

  checkLandStatus(val){
    this.startLoadingAnimation();
    // this.displayLandOwnerDialog = true;
    let reqBody1 = {
      districtCode: val?.R_Dis_Code,
      tehsilCode: val?.R_Teh_Code,
      nvCode: val?.R_Rev_Code,
      khewat: this.kewatNo,
      format: "json",
      farmerId: val?.farmerId
    }

    // let reqBody1 = {
    //   "districtCode": "02",
    //   "tehsilCode": "007",
    //   "nvCode": "01931",
    //   "khewat": this.kewatNo,
    //   "format": "json"
    // }

    // let reqBody2 = {  
    //   "districtCode": "02",  
    //   "tehsilCode": "007",  
    //   "nvCode": "01931",  
    //   "format": "json"
    // }

    // let reqBody2 = {
    //   districtCode: val?.R_Dis_Code,
    //   tehsilCode: val?.R_Teh_Code,
    //   nvCode: val?.R_Rev_Code,
    //   format: "json"
    // }

    this.getLandOwnerDetails(reqBody1);
    // this.getLandKhewatDetails(reqBody2);
  }

  getLandOwnerDetails(reqBody){
    // this.loader.start();
    this.isLandOwnerDetFetching = true;
    this.vendorService 
      .getLandOwnersDetail(reqBody)
      .pipe(first())
      .subscribe({
        next: (resp) => {         
          this.loader.close();
          this.stopLoadingAnimation();
          // this.isLandOwnerDetFetching = false;
          if (resp?.length > 0) {
            this.landOwnerDetails = resp;
            this.landOwnerDetailsErrorMsg = null;

            let reqBody1 = {
              "districtCode": reqBody.districtCode,
              "tehsilCode": reqBody.tehsilCode,
              "nvCode": reqBody?.nvCode,
              "khewat": reqBody?.khewat,
              "format": "json"
            }
            this.getLandGetAreaByKhewat(reqBody)
            this.getKhasraAreaByKhewatNVCode(reqBody1)

          }else{
            this.landOwnerDetails = [];
            this.landOwnerDetailsErrorMsg = `Someting went wrong. Please try again. ${resp}`;;
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data not found',
            });
          }
        },
        error: (err) => {
          this.stopLoadingAnimation();
          this.isLandOwnerDetFetching = false;
          this.showHiddenButton = false;
          this.landOwnerDetailsErrorMsg = `Someting went wrong. Please try again. ${err}`;
          this.landOwnerDetails = [];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  getKhasraAreaByKhewatNVCode(reqBody) {
    // this.loader.start();
    this.vendorService
      .getKhasraAreaKhewatByNVCODE2Khewat(reqBody)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          if(this.request1complete){
            // this.loader.close();
            this.isLandOwnerDetFetching = false;
          }

          if (resp?.status == 200 && resp?.msg != 'Someting went wrong') {
            this.showHiddenButton = true;
            
            this.landDetailedInfo = JSON.parse(resp?.msg);  
          } else {
            this.showHiddenButton = false;
            this.landDetailedInfo = [];

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: `Data not found. ${resp?.msg}`,
            });
          }
        },
        error: (err) => {
          this.showHiddenButton = false;
          this.landDetailedInfo = [];
          if(this.request1complete){
            // this.loader.close();
            this.isLandOwnerDetFetching = false;
          }

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
        complete: () => {
          this.request2complete = true;
        }
      });
  }

  getLandGetAreaByKhewat(reqBody) {
    // this.loader.start();
    this.vendorService
      .getLandGetAreaByKhewat(reqBody)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          if(this.request2complete){
            // this.loader.close();
            this.isLandOwnerDetFetching = false;
          }

          if (resp?.status == 200 && resp?.msg != 'Someting went wrong') {
            this.showHiddenButton = true;
            
            const khewatArea = JSON.parse(resp?.msg)[0]?.area;
            const regex = /(\d+)\s*Kanal\s*(\d+)\s*Marla/;
            const values = khewatArea.match(regex);

            const karnal = values[0] ? parseInt(values[1], 10) : 0;
            const marla = values[2] ? parseInt(values[2], 10) : 0;

            this.landOwnerDetails = this.landOwnerDetails.map(val => ({
              ...val,
              khewat_area: khewatArea,
              valKanal: karnal,
              valMarla: marla,
              totalArea_InAcres:  ((karnal * 20) + marla)/20*0.125,
              owner_hissa: ((karnal * 20) + marla)*((val?.Bhag).split('/').map(Number)[0]/(val?.Bhag).split('/').map(Number)[1])/20*0.125,
            }));
          } else {
            this.showHiddenButton = false;
            this.landOwnerDetails = [];

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: `Data not found. ${resp?.msg}`,
            });
          }
        },
        error: (err) => {
          this.showHiddenButton = false;
          this.landOwnerDetails = [];
          if(this.request1complete){
            // this.loader.close();
            this.isLandOwnerDetFetching = false;
          }

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
        complete: () => {
          this.request1complete = true;
        }
      });
  }

  onSelectStatus() {
    if (this.selectedStatus.flag == 'A') {
      if (this.userID.startsWith('D.A')) {
        this.remarks = 'Checked and Verified';
      } else if (this.userID.startsWith('DDMI')) {
        this.remarks = 'Recommended';
      } else if (this.userID.startsWith('DMICADA')) {
        this.remarks = 'Approved';
      }
    } else {
      this.remarks = null;
    }
  }
}